module.exports = __webpack_public_path__ + "img/iPhone-11.4d8dd859.png";